// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"ef6c15ae","7562":"d8d2097e"}[chunkId] + ".chunk.css";
};